import callApi from 'helpers/callApi';

export const getServiceFee = () => callApi({ url: '/configs/fee' });
